import React from "react";
import { Technology, Integration } from "../../../../../../redux/slices/projects/Types";
import DescriptionSection from "./DescriptionSection";
import EnvironmentDetailsSection from "./EnvironmentDetailsSection";
import ProjectTimelineBlock from "./ProjectTimelineBlock";
import ScreenshotsSection from "./ScreenshotsSection";
import UspDetailsSection from "./UspDetailsSection";

type ProjectDetailsOverviewTabProps = {
  selectedTechnology: Technology;
  selectedIntegration: Integration;
};

const ProjectDetailsOverviewTab: React.FC<ProjectDetailsOverviewTabProps> = ({
  selectedTechnology,
  selectedIntegration,
}) => {
  return (
    <div className="project-details-overview">
      <ProjectTimelineBlock integration={selectedIntegration} />

      <div className="project-details-overview__grid">
        <div className="project-details-overview__left">
          <DescriptionSection
            technologyId={selectedTechnology.technology_id}
            description={selectedTechnology.project_description}
          />

          <ScreenshotsSection
            integrationTypeId={selectedIntegration.integration_type_id || 0}
          />

          <UspDetailsSection
            technologyId={
              selectedTechnology.setting_technology_id ||
              selectedTechnology.technology_id
            }
            integrationTypeId={selectedIntegration.integration_type_id || 0}
            integrationId={selectedIntegration.integration_id}
            documentationId={
              selectedIntegration.environments?.[0]?.documentation_id || 0
            }
          />
        </div>
        <div className="project-details-overview__right">
          <EnvironmentDetailsSection
            technology={selectedTechnology.technology}
            integration={selectedIntegration}
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailsOverviewTab;
